import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(user-mgmt)/organization/$org/user-mgmt/')({
  beforeLoad: () => { throw redirect({ to: '/organization/$org/user-mgmt/users', params: p => ({ org: p.org ?? '' }) }); },
});
